import React from 'react'
import support_licence from "../images/licence-work.png"
function License() {
  return (
    <div>
          <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-6 mt-0">
<h2><b> Water Bottling Plant & ISI License</b></h2>
<h5 className='justify'>Planning to set up a Water Bottling Plant, Packaged Drinking Water Plant, or ISI Category Plant? Before starting your production, you need to obtain several important licenses, registrations, approvals, and permissions from the concerned State and Central Government Departments.</h5>
<h6 className='nearairpotkolkata justify mb-2'>We provide complete license and compliance support for water bottling plants, helping you obtain the necessary approvals and documentation smoothly.</h6>
<br/>
<h2><b>Key Licenses & Approvals</b></h2>
<h6 className='mb-3'>Depending on your plant type and location, you may require:</h6>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"/>
  <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"/>
</svg> Ground Water Abstraction Permission from SWID / concerned Ground Water Authority</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"/>
  <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"/>
</svg> BIS Certification & ISI Mark as applicable</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"/>
  <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"/>
</svg> Pollution Control Board Consent and other environmental approvals</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"/>
  <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"/>
</svg> Pollution Control Board Consent and other environmental approvals</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
  <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"/>
  <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"/>
</svg> Factory License, wherever applicable</p>

<h1><b>Complete Support From Application to Approval</b></h1>
<h6 className='justify'>Our team provides end-to-end assistance for the documentation, application, compliance, and licensing process. We help you understand which approvals are required for your specific plant and support you throughout the process.</h6>

<h5><b>Planning to start a packaged drinking water or ISI-standard water bottling plant? Contact us for professional licensing and compliance support.</b></h5>



                </div>
                 <div className="col-md-6 mt-0">
             <img src={support_licence} className="card-img-top" alt="support_licence"/>

                </div>
                </div>
                </div>
            </div>
    </div>
  )
}

export default License